import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 12H20" />
		<Rect x="9" y="4" width="6" height="16" fill="currentColor" stroke="none" />
	</SVG>
);
